import { createContext, useContext, useState } from 'react';
import { DpValeRedeemerForRegister } from 'integration/generated/transactions/data-contracts';

export type RegisterContextType = {
	dpValeRedeemerForRegister?: DpValeRedeemerForRegister;
};

export type RegisterContext = {
	registerContext: RegisterContextType;
	setRegisterContext: (data: RegisterContextType) => void;
};

export const RegisterContext = createContext<RegisterContext>({} as RegisterContext);

export const RegisterProvider = ({ children }: { children: React.ReactNode }) => {
	const [registerContext, setRegisterContext] = useState<RegisterContextType>({});

	return (
		<RegisterContext.Provider value={{ registerContext, setRegisterContext }}>
			{children}
		</RegisterContext.Provider>
	);
};

export const useRegisterContext = () => {
	const context = useContext(RegisterContext);

	if (!context) {
		throw new Error('useRegisterContext must be used within a PageBlockProvider');
	}

	return context;
};
